/**
 * Token Verification Controller
 */
class TokenEmailController {
    constructor(recoveryPasswordService, $scope, $uibModal, $state) {
        'ngInject';

        //Exposing globals to another methods
        this.recoveryPasswordService = recoveryPasswordService;
        this.$scope = $scope;
        this.$uibModal = $uibModal;
        this.$state = $state;

        this.loading = false;
        this.token = "";
    }

    /**
     * Submit token
     */
    async confirmVerificationToken() {
        if (this.$scope.form.$invalid) return;

        this.loading = true;

        let result;
        result = await this.recoveryPasswordService.confirmEmailVerificationToken(this.token).catch(e => result = e);

        if(result.status === 200){
            result = await this.recoveryPasswordService.sendSmsToken().catch(e => result = e)
            if (result.status === 200) {
                this.showValidTokenModal(result.data);
            } else {
                this.showInvalidTokenModal(result.status);
            }
        }  else if ([400, 401, 403].contains(result.status)) {
            this.showInvalidTokenModal(result.status);
        }

        this.loading = false;
        this.$scope.$apply();
    }

    /**
     * 200 - Process Started Notification Modal
     */
    showValidTokenModal(result) {
        let modalInstance = this.$uibModal.open({
            animation: true,
            templateUrl: 'tokenEmailValidNotification.modal.html',
            controllerAs: '$ctrl',
            size: 'sm',
            controller: ($scope) => {
                "ngInject";
                let $ctrl = $scope.$ctrl;

                $ctrl.ok = () => {
                    modalInstance.close();
                };
            }
        });
        modalInstance.result.then(() => {
            this.showNotificationSmsModal(result);
        })
    };

    showNotificationSmsModal(process) {
        let modalInstance = this.$uibModal.open({
            animation: true,
            templateUrl: 'notificationSms.modal.html',
            controllerAs: '$ctrl',
            size: "sm",
            controller: ($scope, process) => {
                "ngInject";
                let $ctrl = $scope.$ctrl;
                $ctrl.process = process;

                $ctrl.ok = () => modalInstance.close();
            },
            resolve: {
                process: () => process
            }
        });
        sessionStorage.setItem("idProcesso", process.id)
        modalInstance.result.then(() => this.$state.go("tokenSms"));
    };

    /**
     * 40X - Error Notification Modal
     */
    showInvalidTokenModal(code) {
        let modalInstance = this.$uibModal.open({
            animation: true,
            templateUrl: 'invalidTokenEmailNotification.modal.html',
            controllerAs: '$ctrl',
            size: 'sm',
            controller: ($scope, code) => {
                "ngInject";
                let $ctrl = $scope.$ctrl;

                $ctrl.code = code;
                $ctrl.ok = () => {
                    modalInstance.close();
                };
            },
            resolve: {
                code: () => code
            }
        });

        modalInstance.result.then(() => {
            if (code > 400)
                this.$state.go("login")
        }, () => {
            if (code > 403)
                this.$state.go("login")
        });
    };
}

export default TokenEmailController;


// WEBPACK FOOTER //
// ./src/app/components/views/tokenEmail/tokenEmail.controller.js